import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import {SchemeLink} from '../../../../applink/SchemeLink';
import {PromotionBannerItem} from '../../../../design-system/organisms/PromotionBannerItem/PromotionBannerItem';
import {PromotionBannerItem as PromotionBannerItemType} from '../../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../../logging/aggregateAndSendLog';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonItemProps} from '../../type';

export function PromotionBanner({item}: CommonItemProps) {
  const {title, scheme, rightImage, leftImage, eventLog} =
    item as PromotionBannerItemType;
  const {ref, inView, entry} = useInView();

  useEffect(() => {
    if (inView && entry?.target) {
      aggregateAndSendLog({
        targetElem: entry.target as HTMLElement,
        actionType: 'ViewImp',
        actionName: '프로모션배너_노출',
        customProps: {
          user_action: 'imp',
        },
        click: {
          imp_id: 'spromo_b_001',
          imp_provider: 'service',
        },
        viewimp_contents: {
          imp_id: 'spromo_b_001',
          imp_provider: 'service',
          imp_type: 'vimp',
        },
      });
    }
  }, [entry, inView]);

  return (
    <SchemeLink scheme={scheme || undefined}>
      <PromotionBannerItem
        ref={ref}
        {...putTiaraObjectProps(eventLog)}
        className="mb-8pxr"
        bannerTitle={title}
        leftImageUrl={leftImage}
        rightImageUrl={rightImage || undefined}
        onClick={e => LOG_CLICK_EVENT('프로모션배너_클릭', e)}
      />
    </SchemeLink>
  );
}
